import { Button, ButtonGroup, Container, FormControl, InputGroup, Table } from 'react-bootstrap';
import { getDatabase, ref, get } from 'firebase/database';
import React, { useEffect, useState } from 'react';
import { firebaseApp } from '../../../index';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../../Context/AuthContext';
import { RiBarChartBoxFill, RiEdit2Fill } from 'react-icons/ri';

const SrikandiList = () => {
  const navigate = useNavigate();
  const { dbUser, loading } = useAuth();
  const [users, setUsers] = useState<any[]>([]);
  const [search, setSearch] = useState('');
  const [searchQuery, setSearchQuery] = useState('');
  const [filterDate, setFilter] = useState('');
  const [filterRole, setFilterRole] = useState('');
  const sortByName = users.sort((a, b) => (a.name > b.name ? 1 : -1));

  useEffect(() => {
    if (dbUser) {
      if (dbUser.role === 'admin') {
        const database = getDatabase(firebaseApp);
        const usersRef = ref(database, 'users');
        get(usersRef).then((usersSnapshot) => {
          let userList: any[] = [];
          usersSnapshot.forEach((userSnapshot) => {
            userList = userList.concat({
              id: userSnapshot.key,
              ...userSnapshot.val(),
            });
          });
          setUsers(userList.reverse());
        });
      } else if (dbUser.role === 'srikandi_emas') {
        const database = getDatabase(firebaseApp);
        const promises = dbUser.childrenIds.map(async (e) => {
          const userRef = ref(database, `users/${e}`);
          const snapshot = await get(userRef);
          return {
            id: snapshot.key,
            ...snapshot.val(),
          };
        });
        Promise.all(promises).then((users) => {
          setUsers(users.reverse());
        });
      }
    }
  }, [dbUser]);

  const displayRole = (role: string) => {
    switch (role) {
      case 'srikandi':
        return 'Srikandi';
      case 'admin':
        return 'Admin';
      case 'user':
        return 'User';
      case 'srikandi_emas':
        return 'Srikandi Emas';
      case 'srikandi_emas_vip':
        return 'Srikandi Platinum';
      case 'deactivated':
        return 'Deactivated';
      case 'Terminated':
        return 'Terminated';
    }
  };

  const handleChangeSearch = (event: any) => {
    event.persist();
    setSearch(event.target.value);
  };

  const handleSearch = () => {
    setSearchQuery(search);
  };

  const handleClearSearch = () => {
    setSearchQuery('');
    setSearch('');
  };

  const handleEditUser = (user: string) => {
    navigate(`${user}/edit`);
  };

  const handleSalesUser = (user: string) => {
    navigate(`${user}/sales`);
  };

  const handleFilter = () => {
    setFilter((f) => {
      if (f === '') return '↑';
      if (f === '↑') return '↓';
      if (f === '↓') return '';
      return '';
    });
  };
  const handleFilterRole = () => {
    setFilterRole((f) => {
      if (f === '') return '↑↑';
      if (f === '↑↑') return '↓↓';
      if (f === '↓↓') return '';
      return '';
    });
  };

  return (
    <Container>
      <div className=" centerItem">
        <h2 className="header">Srikandi Users</h2>
        <br></br>
        <div className="searchbox">
          <input
            type="text"
            placeholder="Search..."
            className="search"
            onChange={(e) => setSearchQuery(e.target.value)}
          />
        </div>
        <h1></h1>
        <Table bordered hover size="sm" responsive>
          <thead className="tbl-header">
            <tr className="capitalize">
              <th className="countWidth capitalize hidden">#</th>
              <th className="capitalize" style={{ width: '25%', position: 'sticky' }}>
                Name
              </th>
              <th className="capitalize" style={{ width: '28%' }}>
                Email
              </th>
              <th className="capitalize">Coupon Code</th>
              <th className="capitalize" onClick={handleFilterRole} style={{ cursor: 'pointer' }}>Role {filterRole}</th>
              <th className="capitalize">Phone Number</th>
              <th className="capitalize" onClick={handleFilter} style={{ cursor: 'pointer' }}>
                Join Date {filterDate}
              </th>
              <th className="capitalize" onClick={handleFilter} style={{ cursor: 'pointer' }}>
                Date Approved {filterDate}
              </th>
              <th className="capitalize">Action</th>
            </tr>
          </thead>
          <tbody className="tbl-content">
            {users
              .filter(
                (e) =>
                  !searchQuery ||
                  (e.name && e.name.toLowerCase().includes(searchQuery.toLowerCase() || '')) ||
                  (e.email && e.email.toLowerCase().includes(searchQuery.toLowerCase() || '')) ||
                  (e.role && e.role.toLowerCase().includes(searchQuery.toLowerCase() || '')),
              )
              .sort((a, b) => {
                if (filterDate === '↑') return a.registered_at - b.registered_at;
                if (filterDate === '↓') return b.registered_at - a.registered_at;
                if (filterRole === '↓↓') return b.role - a.role;
                if (filterRole === '↑↑') return a.role - b.role;
                return 0;
              })
              .map((e, i) => (
                <tr key={e.id}>
                  <td className="hidden">{i + 1}</td>
                  <td style={{ position: 'sticky' }}>{e.name}</td>
                  <td>{e.email}</td>
                  <td>{e.coupon}</td>
                  <td>{displayRole(e.role)}</td>
                  <td>{e.profile.phone}</td>
                  <td>
                    {e.registered_at ? new Date(e.registered_at).toISOString().slice(0, 10) : 'N/A'}
                  </td>
                  <td>
                    {e.starter_package ? e.starter_package.ordered_at : 'N/A'}
                  </td>
                  <td className="tdicon">
                    <Button
                      onClick={() => handleEditUser(e.id)}
                      id="minicon"
                      style={{
                        fontSize: '12px',
                        color: 'var(--primaryColor)',
                        margin: '2px',
                        backgroundColor: 'var(--secondaryColor)',
                        border: '1px solid var(--secondaryColor)',
                      }}
                    >
                      <RiEdit2Fill />
                    </Button>
                    <Button
                      onClick={() => handleSalesUser(e.id)}
                      id="minicon"
                      style={{
                        fontSize: '12px',
                        color: 'var(--primaryColor)',
                        backgroundColor: 'var(--secondaryColor)',
                        border: '1px solid var(--secondaryColor)',
                      }}
                    >
                      <RiBarChartBoxFill />
                    </Button>
                  </td>
                </tr>
              ))}
          </tbody>
        </Table>{' '}
        <br></br>
        <br></br>
      </div>
    </Container>
  );
};

export default SrikandiList;
